(function(){
  const CFG = window.__KIKKE_PROMO__ || {};
  if (!CFG.enable) return;

  let cartPct = null;
  function formatMoney(cents){
    try{
      if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, CFG.moneyFormat);
    }catch(_){}
    return (cents/100).toFixed(2);
  }

  async function getCartPercent(){
    if (cartPct !== null) return cartPct;
    try{
      const r = await fetch('/cart.js',{credentials:'same-origin'});
      if (!r.ok) return cartPct=0;
      const cart = await r.json();
      const apps=cart.cart_level_discount_applications||[];
      const app=apps.find(a=>a&&a.value_type==='percentage');
      if(app&&app.value)return cartPct=parseFloat(app.value);
      return cartPct=0;
    }catch(_){return cartPct=0;}
  }

  async function applyOnNode(host){
    const base=parseInt(host.getAttribute('data-kikke-price-cents')||'0',10);
    if(!base)return;
    const promoEl=host.querySelector('.kikke-promo');
    if(!promoEl)return;
    let pct=await getCartPercent();
    if(!(pct>0))pct=CFG.percent;
    if(!(pct>0))return;
    const discounted=Math.max(0,Math.round(base*(1-(pct/100))));
    const valueEl=host.querySelector('.kikke-promo__value');
    if(valueEl)valueEl.textContent=formatMoney(discounted);
    promoEl.hidden=false;
    host.classList.add('kikke-has-discount');
  }

  function scan(){
    document.querySelectorAll('[data-kikke-price-cents]:not(.kikke-bound)').forEach(el=>{
      el.classList.add('kikke-bound');
      applyOnNode(el);
    });
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',scan);
  }else{scan();}
  const mo=new MutationObserver(()=>scan());
  mo.observe(document.documentElement,{subtree:true,childList:true});
})();
